import React from 'react';

interface InstitucionalFrameProps {
  /** Nome do arquivo HTML dentro de /public/institucional (ex.: 'index.html'). */
  page: string;
  title: string;
}

/**
 * Renderiza a página institucional a partir do HTML original servido em
 * /public/institucional. O conteúdo roda dentro de um <iframe>, num documento
 * isolado — sem sofrer interferência do Bootstrap/tema global do app — de modo
 * que fica pixel a pixel idêntico ao HTML que foi entregue.
 */
const InstitucionalFrame: React.FC<InstitucionalFrameProps> = ({ page, title }) => {
  return (
    <iframe
      src={`/institucional/${page}`}
      title={title}
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 'none',
      }}
    />
  );
};

export default InstitucionalFrame;
